import * as getAudit from './reducers/get';
import * as getAudits from './reducers/open';
import * as query from './reducers/query';
import * as close from './reducers/close';
import { update } from './reducers/update';
import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    AUDITS_CLOSE_REQUEST: close.request,
    AUDITS_OPEN_REQUEST: getAudits.request,
    AUDITS_OPEN_ERROR: getAudits.error,
    AUDITS_OPEN_FINISH: getAudits.finish,

    AUDIT_REQUEST: getAudit.request,
    AUDIT_ERROR: getAudit.error,
    AUDIT_FINISH: getAudit.finish,

    AUDITS_QUERY_REQUEST: query.request,
    AUDITS_QUERY_ERROR: query.error,
    AUDITS_QUERY_FINISH: query.finish,

    AUDITS_DATA: update,
});
